import React, { useEffect } from "react";
import Footer from "../Footer";
import "./Privacy.css";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Privacy Policy | Chauwk";
  }, []);

  return (
    <>
      <div className="privacy-page">
        {/* Hero Header */}
        <header className="privacy-hero">
          <span className="privacy-badge">Legal &amp; Compliance</span>
          <h1>PRIVACY POLICY</h1>
          <p className="privacy-subtitle">
            How Chauwk Collects, Uses, and Protects Your Personal Information
          </p>
          <div className="privacy-divider" />
        </header>

        {/* Content Wrapper */}
        <main className="privacy-content-wrapper">
          <div className="privacy-card">
            <p>
          THIS PRIVACY POLICY (“PRIVACY POLICY”) SETS FORTH HOW VARIN
          COMMUNICATIONS PRIVATE LIMITED USES AND PROTECTS ANY INFORMATION THAT
          YOU SUBMIT, ON THE PORTAL. THIS PRIVACY POLICY APPLIES ONLY TO PERSONAL
          INFORMATION COLLECTED ON THE PORTAL. BY ACCESSING OR USING THIS PORTAL,
          YOU UNCONDITIONALLY ACCEPT AND AGREE WITHOUT LIMITATION OR QUALIFICATION
          TO THE TERMS AND CONDITIONS OF THIS PRIVACY POLICY. IF YOU DO NOT AGREE
          WITH THE TERMS AND CONDITIONS OF THIS PRIVACY POLICY, PLEASE DO NOT
          PROCEED FURTHER TO USE THIS PORTAL.
          <p>
            <br />
            Access to the Portal (defined below) is subject to Terms of Use
            located at the Portal, capitalized terms used and not defined in this
            Privacy Policy, shall have the same meaning ascribed to them in the
            Terms of Use. Access to the Portal (defined below) is subject to Terms
            of Use located at the Portal, capitalized terms used and not defined
            in this Privacy Policy, shall have the same meaning ascribed to them
            in the Terms of Use.
          </p>
        </p>
        <br></br>
        <h3>1. INTRODUCTION</h3>
        <p>
          Access to the Portal (defined below) is subject to Terms of Use located
          at the Portal, capitalized terms used and not defined in this Privacy
          Policy, shall have the same meaning ascribed to them in the Terms of
          Use.
        </p>
        <br></br>
        <p>
          Access to the Portal (defined below) is subject to Terms of Use located
          at the Portal, capitalized terms used and not defined in this Privacy
          Policy, shall have the same meaning ascribed to them in the Terms of
          Use.
        </p>
        <br />
        <h3>2. INFORMATION WHICH IS COLLECTED</h3>
        <p>
          We may collect and store the following information in relation to the
          Services:
        </p>
        <br></br>
        <p>
          Access to the Portal (defined below) is subject to Terms of Use located
          at the Portal, capitalized terms used and not defined in this Privacy
          Policy, shall have the same meaning ascribed to them in the Terms of
          Use.
        </p>
        <br />
        <p>
          If you use a third-party service like Facebook or Google to log in to
          the Portal (or later connect your Facebook or Google account to your
          Chauwk account) you authorize that third party service to share your
          personal information with us, and us to receive such information,
          including but not limited to your name, mobile number and email address.
        </p>
        <br />
        <p>
          We also collect the Personal Information when other users upload, import
          or share your photos, messages, contact information and or any other
          Personal Information belonging to you. We also collect the Personal
          Information with respect to your communication with other Users. We may
          collect Personal Information in form of details and documents you post
          on the Portal. The messages you send to us, and correspondence we
          receive from other user or third parties about your activities or
          postings on our Portal.
        </p>
        <br />
        <p>
          If you want to support a local business, you can choose to share
          information about it, in the form of a recommendation or by creating a
          Business Page.
        </p>
        <br></br>
        <p>
          If you want to help your community and Chauwk get to know you better,
          you may share information about yourself in your profile, including your
          interests, skills, or even what you love about your community.
        </p>
        <br />
        <p>
          If you want to connect and communicate with community members about
          specific interests, you may share information about your interests.
        </p>
        <br></br>
        <p>
          If you want to communicate with your community members and share Content
          (as defined in our terms and conditions), you might post something on
          the Portal.
        </p>
        <br />
        <p>
          If you want to allow us to show you where you are on your community map,
          tag your posts, photos and events by location, or verify your address
          (where available), you can share this in your settings.
        </p>
        <br />
        <p>
          If you contact support, you are providing us with your contact
          information and a description of the issue so we can respond.
        </p>
        <br />
        <p>
          Data: When you use, or access the Portal, we may also collect and store
          additional information which may or may not personally identify you or
          be identifiable with other information collected. Such information
          includes, without limitation, your device specific information when you
          install access or use our Services, your hardware model, operating
          system information, browser information, internet protocol address,
          device identifiers your usage and log information, information about
          your status in relation to our chat room services, browser types, domain
          name, device locations, and other data involving your use of the Portal
          and/or our Services.{" "}
        </p>
        <br />
        <p>
          Cookie data which comes from “cookies” (small data files stored on your
          computer or mobile device) and similar technologies. Cookie data helps
          us recognize you, remember your preferences, and learn more about you.
          Some, but not all cookie data is associated with your Chauwk account.
          You can configure your browser to reject cookies, but doing so may
          prevent you from logging into our Portal.
        </p>
        <br />
        <p>From third parties and public sources:</p>
        <br />
        <p>
          We engage third parties service providers and partners to provide us
          with your Personal Information, and we also use publicly-available
          sources, such as:
        </p>
        <br />
        <p>
          Our vendors provide us with map information in order to create and
          launch new communities. <br />
          <p>
            Advertisers may provide us with information about their users or
            customers to personalize advertising or measure the performance of
            their advertisements.
          </p>{" "}
          <br></br>
          <p>
            Public sources, such as census data, street addresses, property lot
            maps, and postal address change information, provide us with
            information that helps us understand our members and potential areas
            for expansion.
          </p>
          <br />
          <p>
            Our vendors may provide information about members for advertising
            analytics, personalization, and measurement.
          </p>
          <br />
          <p></p>
        </p>
        <br />
        <h3>3. ACCESS TO THE PORTAL</h3>
        <p>
          Our Portal is not aimed at children under 13 years of age and we will
          not directly collect, use, provide or process in any other form any
          Personal Information of children under the age of 13 years deliberately.
          In addition to being of the minimum required age to use our Portal under
          applicable law, if you are not old enough to have authority to agree to
          our Terms in your country, your parent or guardian must agree to our
          Terms on your behalf. If we learn someone under 13 is using Chauwk, we
          will terminate their account.
        </p>
        <br />
        <h3>4. CHILD SEXUAL ABUSE AND EXPLOITATION (CSAE)</h3>
  
        <p>
          Zero Tolerance Policy: CHAUWK strictly prohibits any content, activity,
          or behavior that promotes or facilitates child sexual abuse and
          exploitation (CSAE).
        </p>
        <br />
        <p>
          User Reporting Mechanism: Our platform allows users to report any
          suspected CSAE content or activity, which will be reviewed and acted
          upon immediately.
        </p>
        <br />
        <p>
          Strict Content Moderation: CHAUWK employs automated detection systems
          and manual reviews to prevent, identify, and remove any content that
          violates CSAE policies.
        </p>
        <br></br>
        <p>
          Compliance with Legal Standards: We adhere to global and local laws,
          including Google Play’s CSAE policy, to ensure a safe digital
          environment.
        </p>
        <br />
        <p>
          Permanent Account Termination: Any user found engaging in CSAE-related
          activities will face immediate and permanent account suspension, along
          with legal action where applicable.
        </p>
        <br />
        <h3>5. APPLICABLE LAW</h3>
        <p>
          This Privacy Policy is governed by the provisions of the Information
          Technology (Reasonable Security Practices and Procedures and Sensitive
          Personal Data or Information) Rules 2011, which is designed to protect
          Personal Information; other relevant laws, and the company policies.
        </p>
        <br />
  
        <h3>6. HOW WE USE PERSONAL INFORMATION</h3>
        <p>
          The Personal Information is collected and used to: (i) provide Services;
          (ii) create and administer your accounts and to improve the quality and
          your experience of the Portal and Services, including but not limited to
          conducting audits and resolving any issues faced; (iii) improve our
          Services; (iv) manage our relationship with you and develop our present
          and future Services; (v) maintain and update our records; (vi) monitor
          suspected fraud, misconducts and unlawful activities and safety and
          security on the Portal. We will not sell, share or disclose your
          information with any third party without your consent, except as
          provided for in this policy. We may also collect Personal Information
          when you interact with our customer service in order to assist you and
          to improve the operation of the Portal and the Services we offer. We use
          business information to create Business Pages, which help Users learn
          about the businesses in their communities. For business or other special
          accounts, we may verify your address using third-party or publicly
          available sources, such as business listings or your website.
        </p>
        <br></br>
        <p>
          You agree that we may also use the Personal Information to contact you
          and deliver information to you that, in some cases, are targeted to your
          interests, such as targeted advertisements, service offerings and
          communications relevant to your use of the Portal. By accepting this
          policy, you expressly agree to receive this information. If you do not
          wish to receive these communications, we encourage you to opt out of the
          receipt of certain communications on your account preferences page.
        </p>
        <br />
  
        <h3>7. DISCLOSURES</h3>
        <p>
          As a rule, we do not share your Personal Information with third parties.
          We won’t sell your personal information. We may share your personal
          information with third parties in limited circumstances, including:
        </p>
        <br></br>
        <p>
          Personal Information shared with other users: As a default setting, the
          Personal Information you share is only shared with or displayed for the
          Users with whom you have connected or with whom you interact through the
          Portal. However, in the event you chose to share the Personal
          Information with public at large, your Personal Information shall be
          displayed on the Portal and shall be visible to any and all users or
          visitors of the Portal. In limited circumstances (for example, to
          highlight popular community resources or topics on the community’s home
          page), we may make short snippets of Content available, without your
          name or other identifying information, to the public (meaning
          non-members and search engines).
        </p>
        <br />
        <p>
          Service Providers: We share your Personal Information with Service
          Providers who are listed, integrated or engaged with the Portal or the
          Company for offering their services to you. As part of their services,
          these Service Provider may share your Personal Information with the
          Users of their choice.
        </p>
        <br />
        <p>
          Affiliates: We may provide Personal Information we collect, to our
          affiliates. For example, we may disclose Personal Information to our
          affiliates in order to respond to your requests for information or
          Services.
        </p>
        <br />
        <p>
          Joint Marketing Arrangements: Where permitted by law, we may share your
          Personal Information with joint marketers with whom we have a marketing
          arrangement, we would require all such joint marketers to have written
          contracts with us that specify appropriate use of your Personal
          Information, require them to safeguard your Personal Information.
        </p>
        <br />
        <p>
          Advertising: You always have a choice as to whether or how you interact
          with an advertisement (for example, by replying or “thanking” them or by
          clicking to learn more about an offer). If you reply to an advertisement
          or other offer, we may share your reply with the advertiser, and we may
          log your interaction as part of tracking the overall effectiveness of
          the advertisement. Our systems are not currently configured to accept
          browsers’ “Do Not Track” signals, as no industry-wide standard for
          handling them has been adopted.
        </p>
        <br />
        <p>
          Business Partners: We may use certain trusted third party and
          individuals to help us provide, analyse, and improve the Services or
          provide marketing, developing, product development or consulting
          services, data storage, payment processing and other features related to
          the Service. These third parties may have access to your Personal
          Information only for purposes of performing these tasks and are under
          obligations similar to those in this Privacy Policy. We may disclose
          your Personal Information to service providers who perform business
          functions or hosting services on our behalf.
        </p>
        <br />
        <p>
          Persons Who Acquire Our Assets or Business: We transfer your Personal
          Information if we are acquired by / we acquire or merge with another
          entity or transfer a part of our business, including the Portal to a
          third party. Any third party or resultant entity that receives your
          Personal Information pursuant to a merger, demerger or business transfer
          shall have the right to continue to use your Personal Information. In
          the event of such a sale or transfer, we reasonably notify you.
        </p>
        <br />
        <p>
          Within the Varin Communications Pvt. Ltd. corporate family: We may share
          your information within our “corporate family”, including between Chauwk
          and Varin Communications Pvt Limited and it’s associate companies, to
          help provide, maintain, and improve Chauwk. As we grow and Chauwk
          becomes available in more cities/countries, we may expand our corporate
          family by establishing local subsidiaries or other affiliates in these
          cities/countries as needed to help us provide Chauwk there.
        </p>
        <br />
        <p>
          Legal and Regulatory Authorities: We may be required to disclose your
          Personal Information due to legal or regulatory requirements. You
          understand that we may have to transfer and process information subject
          to applicable laws in India. s. We may also disclose your Personal
          Information to law enforcement officers or others, in the good faith
          belief that such disclosure is reasonably necessary to enforce this
          Privacy Policy; respond to claims that any Personal Information violates
          the rights of third-parties; or protect the rights, property, or
          personal safety of the Company, our users or the general public. You
          agree and acknowledge that we may not inform you prior to or after
          disclosures made according to this section.
        </p>
        <br />
        <p></p>
        <h3>8. COOKIES</h3>
        <p>
          Our Portal may use "cookies" to enhance User experience. Cookies are
          small encrypted files, that the Application transfers to Your computer’s
          hard drive or on your mobile / tablet device or through any such device
          through which you may access the web through Your web browser that
          enables the Application to recognize your browser and capture and
          remember certain information.
        </p>
        <br></br>
  
        <h3>9. DATA RETENTION</h3>
        <p>
          We will retain your Personal Information for as long as your account is
          active or till the time we are required to provide you the Services. We
          may retain and use your Personal Information as necessary to comply with
          our legal obligations, resolve disputes, and enforce our agreements.
          Consistent with these requirements, we will try to delete your
          information, upon reasonable request. Please note, however, that there
          might be latency in deleting information from our servers and backed-up
          versions. In addition, we do not delete from our servers’ files that you
          have in common with other users
        </p>
        <br></br>
  
        <h3>10. SECURITY</h3>
        <p>
          We value your Personal Information; we will ensure an adequate level of
          protection. We have therefore implemented technology and policies with
          the objective of protecting your Personal Information from unauthorised
          access and improper use and will update these measures as new technology
          becomes available, as appropriate. To protect your Personal Information,
          we have implemented adequate technology. Your Personal Information is
          securely stored at with our cloud service provider or technology
          infrastructure, as may be used by the Company, from time to time.
        </p>
        <br></br>
        <p>
          As a matter of security, we take back-up of systems periodically.
          Although we provide appropriate firewalls and protections. Our systems
          are not hack proof. Data pilferage due to unauthorized hacking, virus
          attacks, technical issues is possible and we take no liabilities or
          responsibilities for it.
        </p>
        <br />
        <p>
          You are solely responsible for all actions of your user account and
          password. Therefore, we do not recommend that you disclose your password
          to any third party. If you choose to share your user account and
          password or any Personal Information with third parties, you are solely
          responsible for the same. If you lose control of your password, you may
          lose substantial control over your Personal Information and may be
          subject to legally binding actions.
        </p>
        <br />
  
        <h3>11. INTERACTION BETWEEN YOU AND THE COMPANY</h3>
        <p>
          We are interested in your views, and we value the Feedback (defined
          below) we receive from you, we therefore have set up blogs and chat
          rooms for providing better Services and to receive your feedbacks.
          However, we do not have control or are responsible for any such Feedback
          or the Personal Information which you make available through these chat
          rooms or the Portal. We encourage you to be careful about what Personal
          Information you disclose in this way. Subject to any applicable law, any
          communication sent by you through the Portal or through the blogs or
          chat rooms or otherwise on the Portal to us (including without
          limitation contents, images, audio, feedback etc. collectively
          "Feedback") is on a non-confidential basis, and we are under no
          obligation to refrain from reproducing, publishing or otherwise using it
          in any way or for any purpose. Your submission of any Feedback shall
          constitute an assignment to us of all worldwide rights, titles and
          interests in all copyrights and other intellectual property rights in
          the Feedback. For this reason, we ask that you do not send us any
          Feedback that you do not wish to assign to us, including any
          confidential information, Personal Information or any original creative
          materials. You shall be responsible for the content and information
          contained in any Feedback sent by you to the Portal or otherwise to us,
          including without limitation for its truthfulness and accuracy.
        </p>
        <br></br>
        <p>
          In the event, you participate in any interactive features of the Portal,
          participate in a survey, contest, promotion, sweepstakes, activity or
          event, request customer support, communicate with us via third party
          social media sites or otherwise communicate with us, we collect the data
          you submit for such participation, which may also include Personal
          Information. We would use such data, as per the terms of this Privacy
          Policy.
        </p>
        <br />
        <h3>12. ACCESSING AND MODIFYING PERSONAL INFORMATION</h3>
        <p>
          In case you need to access, remove, review, and/or make changes to the
          Personal Information that you have provided to us, you may do so by
          login into your User Account. You may change your contact number,
          photos, status messages your name etc. You can make changes in your
          profile at any time by accessing the Portal settings. You understand
          that the Company shall not verify or authenticate the changes made to
          the Personal Information made by you and therefore you take entire
          responsibility of such changes. You confirm that such changes shall be
          in accordance with the terms and conditions of this Privacy Policy.
        </p>
        <br></br>
  
        <h3>13. THIRD PARTY LINKS</h3>
        <p>
          The Portal may from time to time contain hyperlinks to other websites or
          applications. Such links are provided for convenience only and we take
          no responsibility for the content and maintenance of or privacy
          compliance by any linked website. Any hyperlink on our Portal to another
          website or Portal does not imply our endorsement, support, or
          sponsorship of the operator of that website nor of the information
          and/or services which they provide. Company is not a party to any
          transaction between you and such website. Your use of such website is
          subject to the terms and conditions of that website, without any
          reference to this Portal.
        </p>
        <br></br>
  
        <h3>14. INDEMNIFICATION</h3>
        <p>
          You agree to indemnify us and hold us harmless from and against any
          claims arising out of or relating to: (i) Personal Information and
          contents that you submit or share on the Portal (ii) any products you
          sell through the portal, (iii) your violation of any rights of any other
          person in connection with the Portal.
        </p>
        <br></br>
  
        <h3>15. RESERVATION OF RIGHTS</h3>
        <p>
          All rights not expressly granted in this policy are reserved by the
          Company. Nothing contained in this Privacy Policy shall be construed as
          conferring by implication, estoppels or otherwise any license or right
          under any copyright, patent, trademark or other intellectual property
          right of Company or any other person or to any other user.
        </p>
        <br></br>
  
        <h3>16. LIMITATION OF LIABILITY</h3>
        <p>
          Company will not be liable for any damages, direct or indirect,
          incidental or consequential, and all liabilities including for
          negligence, loss or damage such as loss of revenue, unavailability of
          system or loss of data and loss of your Personal Information and for use
          of or inability to use Services of any kind that is offered or to
          provide indemnity or any other remedy to you or any third party.
        </p>
        <br></br>
  
        <h3>17. GOVERNING LAWS AND DISPUTES</h3>
        <p>
          This Agreement shall be construed and governed by the laws of India
          without regard to principles of conflict of laws. The courts in Mumbai,
          India shall have an exclusive jurisdiction over any disputes arising
          under this policy.
        </p>
        <br></br>
  
        <h3>18. CHANGES TO THIS POLICY</h3>
        <p>
          Amendments to this policy will be posted to this Portal and will be
          effective when posted. Your continued use of this Portal following the
          posting of any amendment, modification, or change shall constitute your
          acceptance of the amendment. We request you to check this policy on a
          periodic basis to ascertain if any additional considerations are
          involved with regard to your Personal Information.
        </p>
        <br></br>
  
        <h3>19. COMMUNICATIONS FROM THE PORTAL:</h3>
        <p>
          Special Offers and Updates. We may send You information on the products,
          Services, special deals, and other services of the Company. Out of
          respect for User’s privacy, we present the option to not receive these
          types of communications. User may unsubscribe via the unsubscribe
          mechanism provided in each such communication or by emailing us at the
          email address, provided below.
        </p>
        <br></br>
        <p>
          Service Announcements. On certain occasions or under law, we are
          required to send out service or Portal related announcements. We respect
          User’s privacy, however User may not opt-out of these communications.
          These communications would not be promotional in nature.
        </p>
        <br />
        <h3>20. DELETE ACCOUNT</h3>
        <p>
          For deleting your account information, please send an email to
          support@chauwk.com from the registered email id and we shall do it
          within 48 business hours.
          <p>
            Additionally, user can also initiate the deletion of the account by
            submitting the request from the Chauwk App through the following path
            Account &gt;&gt; Settings &gt;&gt; Privacy Settings &gt;&gt; Delete account.
          </p>
        </p>
        <br></br>
  
        <h3>21. CONTACT US</h3>
        <p>
          If you have questions or concerns or grievances regarding this policy,
          you can contact us as per this policy, or wish to make a complaint,
          please contact us at support@chauwk.com
        </p>
        <br />
        <p>
          Registered Office : Varin Communications Pvt. Ltd., T-Hub Phase 2 : Plot No 1/C, Sy No 83/1, Raidurgam, Knowledge City Rd, Panmaktha, Hyderabad, Telangana 500081.
        </p>

        {/* WhatsApp Business Platform and Messaging Services Continuation */}
        <div
          className="privacy-addon-section"
          style={{
            marginTop: "40px",
            paddingTop: "30px",
            borderTop: "2px solid #e2e8f0",
          }}
        >
          <h2
            style={{
              fontSize: "1.4rem",
              fontWeight: "700",
              color: "#0f172a",
              marginBottom: "16px",
            }}
          >
            WhatsApp Business Platform and Messaging Services
          </h2>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            1. Information We Collect
          </h3>
          <p>
            When you or a business using Chauwk connects a WhatsApp Business Account
            to our Services, we may collect and process information required to provide
            WhatsApp messaging and automation features. This may include:
          </p>
          <ul style={{ margin: "10px 0 16px 24px", padding: 0 }}>
            <li style={{ marginBottom: "8px" }}>
              <strong>Business account information:</strong> Business name, WhatsApp
              business phone number, WhatsApp Business Account ID, phone number ID, and
              other account details made available through Meta.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Message information:</strong> Incoming and outgoing message
              content, sender and recipient phone numbers or identifiers, timestamps,
              message IDs, and delivery, read, or failure status.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Attachments and interactive content:</strong> Images, documents,
              audio, videos, locations, buttons, and other content exchanged through
              WhatsApp, where supported by the features you use.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Messaging configuration:</strong> Message templates, template
              status, messaging preferences, and relevant configuration details.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Technical information:</strong> Webhook events, system logs, error
              records, and other technical information necessary to operate, secure,
              and troubleshoot the integration.
            </li>
          </ul>
          <p>
            The information collected depends on the WhatsApp features enabled and the
            permissions granted when an account is connected.
          </p>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            2. How We Use This Information
          </h3>
          <p>We process WhatsApp-related information to:</p>
          <ul style={{ margin: "10px 0 16px 24px", padding: 0 }}>
            <li style={{ marginBottom: "8px" }}>
              Connect and manage WhatsApp Business Accounts authorised by our
              customers.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Send and receive messages on behalf of the connected business.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Deliver customer support, notifications, and other messaging workflows
              requested by the business.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Process message templates and monitor delivery status.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Enable integrations with customer relationship management systems and
              other connected business tools.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Provide automation features, troubleshoot technical issues, maintain
              security, and prevent misuse.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Comply with applicable legal and regulatory obligations.
            </li>
          </ul>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            3. AI-Powered Automation
          </h3>
          <p>
            Where a business enables AI-powered features, relevant message content and
            contextual information may be processed by AI service providers to
            generate responses, classify messages, assist customer interactions, or
            perform other functions requested by that business.
          </p>
          <p>
            Where AI voice-agent services are enabled, we may also process relevant
            call metadata, audio, transcripts, or information shared during calls,
            depending on the features used and the applicable configuration.
          </p>
          <p>
            Such processing is limited to the services and features enabled by the
            customer and is subject to the applicable privacy practices and terms of
            the relevant service providers.
          </p>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            4. Sharing of WhatsApp-Related Information
          </h3>
          <p>
            We may share or transmit relevant information to the following parties where
            necessary to provide the requested Services:
          </p>
          <ul style={{ margin: "10px 0 16px 24px", padding: 0 }}>
            <li style={{ marginBottom: "8px" }}>
              <strong>Meta and WhatsApp:</strong> To connect WhatsApp Business Accounts
              and send, receive, and manage messages through the WhatsApp Business
              Platform.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Infrastructure and service providers:</strong> Hosting, database,
              security, monitoring, and technical service providers that help us
              operate Chauwk.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>AI and integration providers:</strong> Third-party providers used
              to deliver AI-powered features or integrations that a business chooses to
              enable.
            </li>
            <li style={{ marginBottom: "8px" }}>
              <strong>Legal and regulatory authorities:</strong> Where disclosure is
              required by applicable law or is otherwise permitted under this Privacy
              Policy.
            </li>
          </ul>
          <p>
            Access to information is limited according to the purposes of the relevant
            service and applicable permissions. Third-party services may process
            information under their own applicable terms and privacy policies.
          </p>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            5. Data Retention and Deletion
          </h3>
          <p>
            We retain WhatsApp-related information for as long as necessary to provide
            the requested Services, maintain relevant records, meet legal obligations,
            resolve disputes, and enforce our agreements, subject to applicable law.
          </p>
          <p>
            Businesses may request disconnection of their WhatsApp Business Account from
            Chauwk. Requests to delete personal information associated with the
            Services may be submitted using the contact details provided in this Privacy
            Policy. We will handle such requests in accordance with applicable law and
            our data-retention obligations.
          </p>
          <p>
            Disconnecting an account from Chauwk does not necessarily delete information
            retained independently by Meta, WhatsApp, the connected business, or other
            service providers. Separate deletion requests may be necessary where
            applicable.
          </p>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            6. Business Responsibilities and Customer Choices
          </h3>
          <p>
            Businesses using Chauwk to communicate through WhatsApp are responsible for
            providing appropriate privacy notices and obtaining the permissions,
            consents, and opt-ins required for their communications and use of
            customer information.
          </p>
          <p>
            Businesses must use the WhatsApp Business Platform in accordance with
            applicable WhatsApp policies and laws. Individuals may exercise any
            available communication preferences, including opting out of messages
            where applicable.
          </p>

          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: "700",
              color: "#0f172a",
              marginTop: "24px",
              marginBottom: "10px",
            }}
          >
            7. Security
          </h3>
          <p>
            We use appropriate technical and organisational measures intended to protect
            information processed through our WhatsApp integration against unauthorised
            access, disclosure, alteration, or destruction. However, no electronic
            storage or transmission system can be guaranteed to be completely secure.
          </p>
          <p>
            For questions, access requests, or deletion requests relating to
            information processed by Chauwk, please contact{" "}
            <a
              href="mailto:support@chauwk.com"
              style={{
                color: "#0284c7",
                fontWeight: 600,
                textDecoration: "underline",
              }}
            >
              support@chauwk.com
            </a>
            .
          </p>
        </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
